import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AccountEntity} from './account.entity';
import {DomainKind} from '../enum/domain.kind';
import {SystemEntity} from './system.entity';

@EntityTable('domain', '7e0ec9ed-66e8-4db1-bb7a-4bcdf34c9e8d')
export class DomainEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @JoinColumn(FieldTypeKind.GUID, AccountEntity, false, false, FieldRelationKind.BELONGS_TO, 'account')
    public accountId: string;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.BOOLEAN)
    public default: boolean;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Column(FieldTypeKind.LONG)
    public kind: DomainKind;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, true, false, FieldRelationKind.BELONGS_TO, 'targetSystem')
    public targetSystemId: string;

}
